import React from 'react';

import './RepartidorCard.module.css';

const RepartidorCard = ({ repartidor, isSelected }) => {

    return <div>
        <div className="card_repartidor card">
            <div className="image_container">
                <div class="card_image_flip">
                    <div class={`flip_inner ${repartidor.Imagen ? '' : 'no_front_image'}`}>
                        {
                            repartidor.Imagen ?
                                <div className="front_image">
                                    <img src={repartidor.Imagen} alt={repartidor.Nombre} />
                                </div>
                                : null
                        }
                        <div className="back_image">
                            <span>{repartidor.Id}</span>
                        </div>
                    </div>
                </div>
            </div>
            <div className="card_body">
                <h5 className="capitalize" style={{ color: isSelected ? '#4C7EF8' : '' }}>{repartidor.Nombre.toLowerCase()}</h5>
            </div>
        </div>
    </div>
};

export default RepartidorCard;